import { useMemo } from 'react';
import styles from '@/modules/calendar/components/forecast-game/forecast-frenzy.module.scss';

const PIECES = ['🪙', '🎉', '💰', '⭐'];

export default function ConfettiBurst({ count = 14 }: { count?: number }) {
  // Randomized once per mount (not re-rolled on re-render) — this is a
  // one-shot celebratory burst, not something that should replay/reshuffle.
  const pieces = useMemo(() => {
    return Array.from({ length: count }, (_, i) => {
      const angleDeg = (Math.random() - 0.5) * 160;
      const distance = 60 + Math.random() * 60;
      const rad = (angleDeg * Math.PI) / 180;

      return {
        emoji: PIECES[i % PIECES.length],
        delaySeconds: Math.random() * 0.2,
        x: Math.round(Math.sin(rad) * distance),
        y: Math.round(Math.cos(rad) * distance + 40),
        rotateDeg: Math.round((Math.random() - 0.5) * 360),
        leftPercent: 50 + (Math.random() - 0.5) * 40,
      };
    });
  }, [count]);

  return (
    <div className={styles.confettiLayer}>
      {pieces.map((piece, i) => (
        <span
          key={i}
          className={styles.confettiPiece}
          style={
            {
              left: `${piece.leftPercent}%`,
              animationDelay: `${piece.delaySeconds}s`,
              '--confetti-end': `translate(${piece.x}px, ${piece.y}px) rotate(${piece.rotateDeg}deg)`,
            } as React.CSSProperties
          }
        >
          {piece.emoji}
        </span>
      ))}
    </div>
  );
}
